(function (_, Kotlin) {
  'use strict';
  var Pair = Kotlin.kotlin.Pair;
  var to = Kotlin.kotlin.to_ujzrz7$;
  var hashMapOf = Kotlin.kotlin.collections.hashMapOf_qfcya0$;
  var Regex_init = Kotlin.kotlin.text.Regex_init_61zpoe$;
  var ensureNotNull = Kotlin.ensureNotNull;
  var unboxChar = Kotlin.unboxChar;
  var toBoxedChar = Kotlin.toBoxedChar;
  var toChar = Kotlin.toChar;
  var toInt = Kotlin.kotlin.text.toInt_6ic1pp$;
  var toInt_0 = Kotlin.kotlin.text.toInt_pdl1vz$;
  var NumberFormatException = Kotlin.kotlin.NumberFormatException;
  var mutableListOf = Kotlin.kotlin.collections.mutableListOf_i5x0yv$;
  var toLongOrNull = Kotlin.kotlin.text.toLongOrNull_pdl1vz$;
  var equals = Kotlin.equals;
  var IBAN_MAX_LENGTH;
  var IBAN_FORMATS;
  var throwCCE = Kotlin.throwCCE;
  var Array_0 = Array;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_ww73n8$;
  function validateIban(value) {
    var iban = Regex_init('\\s').replace_x2uqeu$(value, '');
    if (!Regex_init('^[\\dA-Z]+$').matches_6bul2c$(iban)) {
      return false;
    }
    var len = iban.length;
    var tmp$ = IBAN_FORMATS.get_11rb$(iban.substring(0, 2)) == null;
    if (!tmp$) {
      tmp$ = len !== ensureNotNull(IBAN_FORMATS.get_11rb$(iban.substring(0, 2))).first;
    }
    if (tmp$) {
      return false;
    }
    var tmp$_0;
    var $receiver_0 = Kotlin.isCharSequence(tmp$_0 = iban) ? tmp$_0 : throwCCE();
    var startIndex = 0;
    var endIndex = $receiver_0.length - 1 | 0;
    var startFound = false;
    while (startIndex <= endIndex) {
      var index = !startFound ? startIndex : endIndex;
      var match = unboxChar(toBoxedChar($receiver_0.charCodeAt(index))) <= 32;
      if (!startFound) {
        if (!match)
          startFound = true;
        else
          startIndex = startIndex + 1 | 0;
      }
       else {
        if (!match)
          break;
        else
          endIndex = endIndex - 1 | 0;
      }
    }
    var symbols = Kotlin.subSequence($receiver_0, startIndex, endIndex + 1 | 0).toString();
    if (symbols.length < 15 || symbols.length > 34) {
      return false;
    }
    var swapped = symbols.substring(4) + symbols.substring(0, 4);
    var array = Array_0(swapped.length);
    var tmp$_1;
    tmp$_1 = array.length - 1 | 0;
    for (var i = 0; i <= tmp$_1; i++) {
      array[i] = toBoxedChar(swapped.charCodeAt(i));
    }
    var charArray = array;
    var destination = ArrayList_init(charArray.length);
    var tmp$_2;
    for (tmp$_2 = 0; tmp$_2 !== charArray.length; ++tmp$_2) {
      var item = charArray[tmp$_2];
      destination.add_11rb$(unboxChar(item) | 0);
    }
    var tmp$_3;
    var accumulator = 0;
    tmp$_3 = destination.iterator();
    while (tmp$_3.hasNext()) {
      var element = tmp$_3.next();
      var previousMod = accumulator;
      var charValue = toInt(String.fromCharCode(toChar(element)), 36);
      var factor = charValue < 10 ? 10 : 100;
      accumulator = (Kotlin.imul(factor, previousMod) + charValue | 0) % 97;
    }
    return accumulator === 1;
  }
  var MIN_NIF;
  var MAX_NIF;
  function validateNif(nif) {
    return validateNif_1(nif.toString());
  }
  function validateNif_0(nif) {
    return validateNif_1(nif.toString());
  }
  function validateNif_1(nif) {
    var tmp$;
    var nifAsInt;
    try {
      nifAsInt = toInt_0(nif);
    }
     catch (e) {
      if (Kotlin.isType(e, NumberFormatException)) {
        return false;
      }
       else
        throw e;
    }
    if (nifAsInt < MIN_NIF || nifAsInt > MAX_NIF) {
      return false;
    }
    var checkDigitSum = toInt_0(String.fromCharCode(nif.charCodeAt(0))) * 9 | 0;
    tmp$ = mutableListOf([2, 3, 4, 5, 6, 7, 8]).iterator();
    while (tmp$.hasNext()) {
      var i = tmp$.next();
      checkDigitSum = checkDigitSum + Kotlin.imul(toInt_0(String.fromCharCode(nif.charCodeAt(i - 1 | 0))), 10 - i | 0) | 0;
    }
    checkDigitSum = 11 - checkDigitSum % 11 | 0;
    if (checkDigitSum === 10 || checkDigitSum === 11) {
      checkDigitSum = 0;
    }
    return checkDigitSum === toInt_0(String.fromCharCode(nif.charCodeAt(8)));
  }
  function isEmpNomeIndividual(nif) {
    var firstDigit = nif.charCodeAt(0);
    return firstDigit === 49 || firstDigit === 50;
  }
  function isEmpNomeIndividual_0(nif) {
    return isEmpNomeIndividual(nif.toString());
  }
  function isEmpNomeIndividual_1(nif) {
    return isEmpNomeIndividual(nif.toString());
  }
  function isGrupoSociedade(nif) {
    var firstDigit = nif.charCodeAt(0);
    return firstDigit === 53;
  }
  function isGrupoSociedade_0(nif) {
    return isGrupoSociedade(nif.toString());
  }
  function isGrupoSociedade_1(nif) {
    return isGrupoSociedade(nif.toString());
  }
  function isEstado(nif) {
    var firstDigit = nif.charCodeAt(0);
    return firstDigit === 54;
  }
  function isEstado_0(nif) {
    return isEstado(nif.toString());
  }
  function isEstado_1(nif) {
    return isEstado(nif.toString());
  }
  function isPessoaColetiva(nif) {
    var firstDigit = nif.charCodeAt(0);
    return firstDigit === 57;
  }
  function isPessoaColetiva_0(nif) {
    return isPessoaColetiva(nif.toString());
  }
  function isPessoaColetiva_1(nif) {
    return isPessoaColetiva(nif.toString());
  }
  function isSingular(nif) {
    var firstDigit = nif.charCodeAt(0);
    return firstDigit === 49 || firstDigit === 50 || firstDigit === 51 || firstDigit === 52;
  }
  function isSingular_0(nif) {
    return isSingular(nif.toString());
  }
  function isSingular_1(nif) {
    return isSingular(nif.toString());
  }
  function isNaoResidenteSingular(nif) {
    return nif.charCodeAt(0) === 53 && nif.charCodeAt(1) === 50;
  }
  function isNaoResidenteSingular_0(nif) {
    return isNaoResidenteSingular(nif.toString());
  }
  function isNaoResidenteSingular_1(nif) {
    return isNaoResidenteSingular(nif.toString());
  }
  var NISS_LENGTH;
  var CHECK_DIGIT_POSITION;
  function validateNissSingular(niss) {
    if (!validateAllNiss(niss)) {
      return false;
    }
    return toInt_0(String.fromCharCode(niss.charCodeAt(0))) === 1;
  }
  function validateAllNiss(niss) {
    if (toLongOrNull(niss) == null) {
      return false;
    }
    if (niss.length !== NISS_LENGTH) {
      return false;
    }
    if (equals(niss, '00000000000')) {
      return false;
    }
    return checkDigitNiss(niss);
  }
  function checkDigitNiss(niss) {
    var array = new Int32Array(11);
    var valores = new Int32Array([29, 23, 19, 17, 13, 11, 7, 5, 3, 2]);
    var total = 0;
    var check;
    var digit = toInt_0(String.fromCharCode(niss.charCodeAt(CHECK_DIGIT_POSITION)));
    var i = 0;
    var j = 0;
    while (i < (niss.length - 1 | 0)) {
      array[i] = Kotlin.imul(toInt_0(String.fromCharCode(niss.charCodeAt(i))), valores[j]);
      total = total + array[i] | 0;
      i = i + 1 | 0;
      j = j + 1 | 0;
    }
    var resto = total % 10;
    check = 9 - resto | 0;
    if (check === digit) {
      return true;
    }
    return false;
  }
  var package$pt = _.pt || (_.pt = {});
  var package$at = package$pt.at || (package$pt.at = {});
  var package$lfat = package$at.lfat || (package$at.lfat = {});
  var package$commonjvm = package$lfat.commonjvm || (package$lfat.commonjvm = {});
  var package$validator = package$commonjvm.validator || (package$commonjvm.validator = {});
  Object.defineProperty(package$validator, 'IBAN_MAX_LENGTH', {
    get: function () {
      return IBAN_MAX_LENGTH;
    }
  });
  Object.defineProperty(package$validator, 'IBAN_FORMATS', {
    get: function () {
      return IBAN_FORMATS;
    }
  });
  package$validator.validateIban_61zpoe$ = validateIban;
  Object.defineProperty(package$validator, 'MIN_NIF', {
    get: function () {
      return MIN_NIF;
    }
  });
  Object.defineProperty(package$validator, 'MAX_NIF', {
    get: function () {
      return MAX_NIF;
    }
  });
  package$validator.validateNif_za3lpa$ = validateNif;
  package$validator.validateNif_s8cxhz$ = validateNif_0;
  package$validator.validateNif_61zpoe$ = validateNif_1;
  package$validator.isEmpNomeIndividual_61zpoe$ = isEmpNomeIndividual;
  package$validator.isEmpNomeIndividual_s8cxhz$ = isEmpNomeIndividual_0;
  package$validator.isEmpNomeIndividual_za3lpa$ = isEmpNomeIndividual_1;
  package$validator.isGrupoSociedade_61zpoe$ = isGrupoSociedade;
  package$validator.isGrupoSociedade_za3lpa$ = isGrupoSociedade_0;
  package$validator.isGrupoSociedade_s8cxhz$ = isGrupoSociedade_1;
  package$validator.isEstado_61zpoe$ = isEstado;
  package$validator.isEstado_za3lpa$ = isEstado_0;
  package$validator.isEstado_s8cxhz$ = isEstado_1;
  package$validator.isPessoaColetiva_61zpoe$ = isPessoaColetiva;
  package$validator.isPessoaColetiva_za3lpa$ = isPessoaColetiva_0;
  package$validator.isPessoaColetiva_s8cxhz$ = isPessoaColetiva_1;
  package$validator.isSingular_61zpoe$ = isSingular;
  package$validator.isSingular_s8cxhz$ = isSingular_0;
  package$validator.isSingular_za3lpa$ = isSingular_1;
  package$validator.isNaoResidenteSingular_61zpoe$ = isNaoResidenteSingular;
  package$validator.isNaoResidenteSingular_s8cxhz$ = isNaoResidenteSingular_0;
  package$validator.isNaoResidenteSingular_za3lpa$ = isNaoResidenteSingular_1;
  Object.defineProperty(package$validator, 'NISS_LENGTH', {
    get: function () {
      return NISS_LENGTH;
    }
  });
  Object.defineProperty(package$validator, 'CHECK_DIGIT_POSITION', {
    get: function () {
      return CHECK_DIGIT_POSITION;
    }
  });
  package$validator.validateNissSingular_61zpoe$ = validateNissSingular;
  package$validator.validateAllNiss_61zpoe$ = validateAllNiss;
  package$validator.checkDigitNiss_61zpoe$ = checkDigitNiss;
  IBAN_MAX_LENGTH = 34;
  IBAN_FORMATS = hashMapOf([to('AL', new Pair(28, '^AL[0-9]{10}[0-9A-Za-z]{16}$')), to('DZ', new Pair(24, '^DZ[0-9]{22}$')), to('AD', new Pair(24, '^AD[0-9]{10}[0-9A-Za-z]{12}$')), to('AO', new Pair(25, '^AO06[0-9]{21}$')), to('AT', new Pair(20, '^AT[0-9]{18}$')), to('AZ', new Pair(28, '^AZ[0-9]{2}[A-Z]{4}[0-9A-Za-z]{20}$')), to('BH', new Pair(22, '^BH[0-9]{2}[A-Z]{4}[0-9A-Za-z]{14}$')), to('BE', new Pair(16, '^BE[0-9]{14}$')), to('BJ', new Pair(28, '^BJ[0-9]{2}[A-Z][0-9]{23}$')), to('BA', new Pair(20, '^BA39[0-9]{16}$')), to('BR', new Pair(29, '^BR[0-9]{25}[A-Z][0-9A-Za-z]$')), to('BG', new Pair(22, '^BG[0-9]{2}[A-Z]{4}[0-9]{6}[0-9A-Za-z]{8}$')), to('BF', new Pair(27, '^BF[0-9]{25}$')), to('BI', new Pair(16, '^BI[0-9]{14}$')), to('CM', new Pair(27, '^CM[0-9]{25}$')), to('CV', new Pair(25, '^CV64[0-9]{21}$')), to('CG', new Pair(27, '^CG[0-9]{25}$')), to('CR', new Pair(21, '^CR[0-9]{19}$')), to('HR', new Pair(21, '^HR[0-9]{19}$')), to('CY', new Pair(28, '^CY[0-9]{10}[0-9A-Za-z]{16}$')), to('CZ', new Pair(24, '^CZ[0-9]{22}$')), to('DK', new Pair(18, '^DK[0-9]{16}$')), to('FO', new Pair(18, '^FO[0-9]{16}$')), to('GL', new Pair(18, '^GL[0-9]{16}$')), to('DO', new Pair(28, '^DO[0-9]{2}[0-9A-Za-z]{4}[0-9]{20}$')), to('EG', new Pair(27, '^EG[0-9]{25}$')), to('EE', new Pair(20, '^EE[0-9]{18}$')), to('FI', new Pair(18, '^FI[0-9]{16}$')), to('FR', new Pair(27, '^FR[0-9]{12}[0-9A-Za-z]{11}[0-9]{2}$')), to('GA', new Pair(27, '^GA[0-9]{25}$')), to('GE', new Pair(22, '^GE[0-9]{2}[A-Z]{2}[0-9]{16}$')), to('DE', new Pair(22, '^DE[0-9]{20}$')), to('GI', new Pair(23, '^GI[0-9]{2}[A-Z]{4}[0-9A-Za-z]{15}$')), to('GR', new Pair(27, '^GR[0-9]{9}[0-9A-Za-z]{16}$')), to('GT', new Pair(28, '^GT[0-9]{2}[0-9A-Za-z]{24}$')), to('HU', new Pair(28, '^HU[0-9]{26}$')), to('IS', new Pair(26, '^IS[0-9]{24}$')), to('IR', new Pair(26, '^IR[0-9]{24}$')), to('IE', new Pair(22, '^IE[0-9]{2}[A-Z]{4}[0-9]{14}$')), to('IL', new Pair(23, '^IL[0-9]{21}$')), to('IT', new Pair(27, '^IT[0-9]{2}[A-Z][0-9]{10}[0-9A-Za-z]{12}$')), to('JO', new Pair(30, '^JO[0-9]{2}[A-Z]{4}[0-9]{22}$')), to('CI', new Pair(28, '^CI[0-9]{2}[A-Z][0-9]{23}$')), to('KZ', new Pair(20, '^KZ[0-9]{5}[0-9A-Za-z]{13}$')), to('KW', new Pair(30, '^KW[0-9]{2}[A-Z]{4}[0-9A-Za-z]{22}$')), to('LV', new Pair(21, '^LV[0-9]{2}[A-Z]{4}[0-9A-Za-z]{13}$')), to('LB', new Pair(28, '^LB[0-9]{6}[0-9A-Za-z]{20}$')), to('LI', new Pair(21, '^LI[0-9]{7}[0-9A-Za-z]{12}$')), to('LT', new Pair(20, '^LT[0-9]{18}$')), to('LU', new Pair(20, '^LU[0-9]{5}[0-9A-Za-z]{13}$')), to('MK', new Pair(19, '^MK07[0-9]{3}[0-9A-Za-z]{10}[0-9]{2}$')), to('MG', new Pair(27, '^MG[0-9]{25}$')), to('ML', new Pair(28, '^ML[0-9]{2}[A-Z][0-9]{23}$')), to('MT', new Pair(31, '^MT[0-9]{2}[A-Z]{4}[0-9]{5}[0-9A-Za-z]{18}$')), to('MR', new Pair(27, '^MR13[0-9]{23}$')), to('MU', new Pair(30, '^MU[0-9]{2}[A-Z]{4}[0-9]{19}[A-Z]{3}$')), to('MD', new Pair(24, '^MD[0-9]{2}[0-9A-Za-z]{20}$')), to('MC', new Pair(27, '^MC[0-9]{12}[0-9A-Za-z]{11}[0-9]{2}$')), to('ME', new Pair(22, '^ME25[0-9]{18}$')), to('MZ', new Pair(25, '^MZ[0-9]{23}$')), to('NL', new Pair(18, '^NL[0-9]{2}[A-Z]{4}[0-9]{10}$')), to('NO', new Pair(15, '^NO[0-9]{13}$')), to('PK', new Pair(24, '^PK[0-9]{2}[A-Z]{4}[0-9A-Za-z]{16}$')), to('PS', new Pair(29, '^PS[0-9]{2}[A-Z]{4}[0-9A-Za-z]{21}$')), to('PL', new Pair(28, '^PL[0-9]{26}$')), to('PT', new Pair(25, '^PT50[0-9]{21}$')), to('QA', new Pair(29, '^QA[0-9]{2}[A-Z]{4}[0-9]{14}[A-Z]{7}$')), to('RO', new Pair(24, '^RO[0-9]{2}[A-Z]{4}[0-9A-Za-z]{16}$')), to('SM', new Pair(27, '^SM[0-9]{2}[A-Z][0-9]{10}[0-9A-Za-z]{12}$')), to('SA', new Pair(24, '^SA[0-9]{4}[0-9A-Za-z]{18}$')), to('SN', new Pair(28, '^SN[0-9]{2}[A-Z][0-9]{23}$')), to('RS', new Pair(22, '^RS[0-9]{20}$')), to('SK', new Pair(24, '^SK[0-9]{22}$')), to('SI', new Pair(19, '^SI56[0-9]{15}$')), to('ES', new Pair(24, '^ES[0-9]{22}$')), to('SE', new Pair(24, '^SE[0-9]{22}$')), to('CH', new Pair(21, '^CH[0-9]{7}[0-9A-Za-z]{12}$')), to('TN', new Pair(24, '^TN59[0-9]{20}$')), to('TR', new Pair(26, '^TR[0-9]{7}[0-9A-Za-z]{17}$')), to('AE', new Pair(23, '^AE[0-9]{21}$')), to('UA', new Pair(29, '^UA[0-9]{27}$')), to('GB', new Pair(22, '^GB[0-9]{2}[A-Z]{4}[0-9]{14}$')), to('VG', new Pair(24, '^VG[0-9]{2}[A-Z]{4}[0-9A-Za-z]{16}$'))]);
  MIN_NIF = 100000000;
  MAX_NIF = 999999999;
  NISS_LENGTH = 11;
  CHECK_DIGIT_POSITION = 10;
  Kotlin.defineModule('lf-at', _);
  return _;
}(module.exports, require('kotlin')));

//# sourceMappingURL=lf-at.js.map
